/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import {
  formatDateTime,
  getBigData,
} from 'services/data-energy-net/energy-net-data/data';

export function EnergyNetData({ fromTime }) {
  const formattedFromTime = formatDateTime(fromTime); // needs to be 'YYYY-MM-DD HH:MM:SS.MMM'
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [json, setJson] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        console.log('EnergyNetData: json loading');
        const res = await fetch('/scenario-data/transposed-hash.json'); // served from /public
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const jsonResult = await res.json();
        setJson(jsonResult);
        console.log('EnergyNetData: json loaded');
      } catch (e) {
        setError(e?.message || String(e));
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (json === null) {
        console.log('EnergyNetData: Retry rendering when json has loaded');
        return;
      }
      try {
        console.log(
          'EnergyNetData: rendering with fromTime:',
          formattedFromTime,
        );
        const result = getBigData(
          formattedFromTime,
          'sim-pottugnen-router-1',
          json,
        );
        setError(null);
        setData(result);
      } catch (e) {
        setError(e?.message || String(e));
      }
    })();
  }, [json, formattedFromTime]);

  if (error) {
    return <div style={{ whiteSpace: 'pre-wrap' }}>Error: {error}</div>;
  }
  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div style={{ textAlign: 'left' }}>
        <div>
          Consumption last hour:{' '}
          <p style={{ color: '#3170C8', display: 'inline' }}>
            <b>{(data.EnergyConsumptionLastHour_Wh / 1000).toFixed(2)}</b>
          </p>{' '}
          kWh{' '}
        </div>
        Production from solar last hour:{' '}
        <p style={{ color: '#3170C8', display: 'inline' }}>
          <b>{(data.SolarProductionLastHour_Wh / 1000).toFixed(2)}</b>
        </p>{' '}
        kWh <br />
        Current solar power:{' '}
        <p style={{ color: '#3170C8', display: 'inline' }}>
          <b>{(data.SolarPower_W / 1000).toFixed(2)}</b>
        </p>{' '}
        kW <br />
        Current total battery charge:{' '}
        <p style={{ color: '#3170C8', display: 'inline' }}>
          <b>{data.BatteryCapacityTot_Ah}</b>
        </p>{' '}
        Ah <br />
      </div>
    </div>
  );
}
